<template>
    <v-card :title="title" >
        <template slot="extra" v-if="moreUrl">
            <a :href="moreUrl" style="color: #eef0f1">MORE+</a>
        </template>
        <Row :gutter="16" v-if="news">
            <i-col :sm="12">
                <div class="news-card">
                    <Row :gutter="12" type="flex" align="middle">
                        <i-col span="10">
                            <a class="news-img" href="#" @click.prevent="">
                                <img :src="news.img" />
                            </a>
                        </i-col>
                        <i-col span="14">
                            <div class="news-title" :title="news.title">
                                <a href="#" @click.prevent="">{{news.title}}</a>
                            </div>
                            <div class="news-summary">
                                {{news.summary}}
                            </div>
                            <div class="news-time">{{news.time}}</div>
                        </i-col>
                    </Row>
                </div>
            </i-col>
            <i-col :sm="12" >
                <ul class="list-wrap">
                    <li class="list-item" v-for="item in list">
                        <a class="item-title" href="#" @click.prevent="">
                            <Icon type="ios-arrow-forward" />
                            {{item.title}}
                        </a>
                        <span class="item-time">{{item.time}}</span>
                    </li>
                </ul>
            </i-col>
        </Row>

        <ul class="list-wrap" v-else >
            <li class="list-item" v-for="item in list">
                <router-link class="item-title" :to="item.link||''" >
                    <Icon type="ios-arrow-forward" />
                    {{item.title}}
                </router-link>
                <span class="item-time">{{item.time}}</span>
            </li>
        </ul>
    </v-card>
</template>
<style lang="less" scoped>
    @import "../pages/common/mui";
    .news-card{
        padding: 8px;
        a.news-img{
            width: 90%;
            margin: 4px auto;
            /*border: 1px solid lightgray;*/
            display: block;

            & img{
                width: 100%;
            }
        }
        & .news-title{
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            color: rgb(82,140,145);
            margin: 6px 0;
        }
        & .news-summary{
            color: #888888;
            height: 96px;
            line-height: 24px;
            overflow: hidden;
        }
        & .news-time{
            color: #888888;
            text-align: right;
            padding-right: 8px;
        }
    }
    .list-wrap{
        list-style: none;
        margin: 8px 0;

        & .list-item{
            height: 30px;
            line-height: 30px;
            display: flex;
            font-size: 14px;

            & .item-title{
                flex: 1;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow: hidden;
                padding-left: 8px;
            }
            & .item-time{
                padding: 0 8px;
                color: #999999;
            }
        }
    }
</style>
<script>
    import VCard from "./Card";
    export default {
        name:'v-news-card',
        data() {
            return {
            }
        },
        props:['title','news','list','moreUrl'],
        components: {VCard}
    }
</script>
